/**
 * Ingredientes / INCI tab switcher on the product page.
 */
class ProductIngredientsTabs {
  /** @param {HTMLElement} root */
  constructor(root) {
    this.root = root;
    this.tabs = root.querySelectorAll('[data-ingredients-tab]');
    this.panels = root.querySelectorAll('[data-ingredients-panel]');
    this.#moveHighlights();
    this.#bindTabs();
  }

  #moveHighlights() {
    const slot = this.root.querySelector('[data-ingredients-highlights-slot]');
    const tags = document.querySelector('.product-details [class*="__text_ingredientes_tags"]');

    if (!slot || !tags) return;

    const tagsBlock = tags.closest('rte-formatter') || tags.closest('.text-block') || tags.parentElement;
    if (!tagsBlock) return;

    slot.replaceChildren(tagsBlock);

    const sourceGroup = document.querySelector('.product-details .group-block:has([class*="__text_QFgWQG"])');
    if (sourceGroup) {
      sourceGroup.hidden = true;
    }
  }

  #bindTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-ingredients-tab');
        if (!target || tab.classList.contains('is-active')) return;

        this.tabs.forEach((button) => {
          const isActive = button === tab;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.panels.forEach((panel) => {
          const isMatch = panel.getAttribute('data-ingredients-panel') === target;
          panel.hidden = !isMatch;
        });
      });
    });
  }

  static init() {
    document.querySelectorAll('.ingredients-accordion-block[data-ingredients-tabs]').forEach((root) => {
      if (root.dataset.ingredientsTabsReady === 'true') return;
      root.dataset.ingredientsTabsReady = 'true';
      new ProductIngredientsTabs(root);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ProductIngredientsTabs.init());
} else {
  ProductIngredientsTabs.init();
}

document.addEventListener('shopify:section:load', () => ProductIngredientsTabs.init());
